import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Utils, getAppOrigin } from '../../utils';
import './signup.css';
import logo from '../../assets/notifysphere-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setLoading(true);
        try {
            const response = await fetch(Utils.baseurl + 'forgot-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: email.trim(),
                    origin: getAppOrigin()
                })
            });
            const result = await response.json();

            if (result.status) {
                setSuccess(result.message || 'If an account exists with this email, you will receive a password reset link shortly. Check your inbox and spam folder.');
            } else {
                setError(result.message || 'Something went wrong.');
            }
        } catch (err) {
            setError('Connection error. Please try again.');
        }
        setLoading(false);
    };

    return (
        <div className="signup_page">
            <div className="signup_page_inner">
                <div className="page_logo">
                    <a href="/">
                        <img src={logo} alt="notifySphere" />
                    </a>
                </div>
                <div className="form_outer">
                    <div className="text-center">
                        <div className="form_heading">
                            <h1>Forgot password</h1>
                            <p style={{ color: 'black' }}>Enter your email and we'll send you a reset link.</p>
                        </div>
                    </div>

                    {error && (
                        <div className="alert alert-danger">
                            <span>{error}</span>
                        </div>
                    )}
                    {success && (
                        <div className="alert alert-success">
                            <span>{success}</span>
                        </div>
                    )}

                    <div className="login_form">
                        <form onSubmit={handleSubmit}>
                            <div className="input_boxes">
                                <div className="email_box">
                                    <label htmlFor="forgot_email">Email Address</label>
                                    <div className="email_input">
                                        <input
                                            id="forgot_email"
                                            type="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="user@notifysphere.com"
                                            required
                                            spellCheck="false"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="signup_button">
                                <button
                                    style={{ backgroundColor: loading ? '#686abd' : 'rgb(67, 70, 206)' }}
                                    disabled={loading}
                                    type="submit"
                                >
                                    {loading ? <FontAwesomeIcon icon={faSpinner} spin size="1x" /> : <span>Send reset link</span>}
                                </button>
                            </div>
                        </form>
                        <div className="already_acc">
                            <span color="dark">
                                Already have an account? <Link to="/signIn"> Sign in</Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
